// extracted by mini-css-extract-plugin
export default {"tenure":"BipX0oQxEGXfic_G7mmg","text":"n77xVqyF4eBMCzP9LyG8"};